import { Card, Grid } from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/es'; // importa y registra el locale
import { useContext, useEffect } from 'react';
import { SolicitudCoberturaContext } from '../context';
import { GraficoBar } from './GraficoBar';
import { useSolicitudCoberturaIniciadoAutorizadoBarraApilada } from '../hooks';
dayjs.locale('es'); // activa el idioma español

export const IniciadoAutorizadoAnualBarraApilada = () => {
  const { anualList, anualDate } = useContext(SolicitudCoberturaContext);
  const { datosAnualesBarrasApiladas, getDatosAnualesBarrasApiladas } =
    useSolicitudCoberturaIniciadoAutorizadoBarraApilada({
      anualList,
      anualDate,
    });

  useEffect(() => {
    if (anualList?.length > 0 && anualDate) {
      getDatosAnualesBarrasApiladas();
    }
  }, [anualList, anualDate]);

  return (
    <Card sx={{ px: 3, py: 3, width: '100%', maxWidth: '800px', height: '300px' }}>
      <GraficoBar
        labels={datosAnualesBarrasApiladas?.labels || []}
        datasets={datosAnualesBarrasApiladas?.datasets || []}
        options={{
          plugins: {
            title: {
              text: 'Histórico de autorizaciones ' + dayjs(anualDate).format('YYYY'),
              display: true,
            },
            legend: { position: 'bottom' },
          },
        }}
      />
    </Card>
  );
};
